import React from 'react';
import PropTypes from 'prop-types';

const ICON_SIZE = 24;

function SkypeIcon({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={ICON_SIZE}
      height={ICON_SIZE}
      viewBox="0 0 24 24"
    >
      <path
        fillRule="evenodd"
        d="M11.8 16.6c-2.6 0-3.8-1.4-3.8-2.3a.8.8 0 0 1 1-.9c1 0 .7 1.7 2.8 1.7 1 0 1.7-.7 1.7-1.3 0-.3-.2-.7-.9-.9l-2.3-.6C8.4 11.8 8 10.8 8 9.8c0-2 1.8-2.7 3.6-2.7 1.6 0 3.5 1 3.5 2.1 0 .5-.5.8-1 .8-1 0-.8-1.3-2.7-1.3-1 0-1.4.4-1.4 1 0 .7.7.9 1.4 1l1.7.4c1.9.4 2.4 1.5 2.4 2.6 0 1.6-1.3 2.9-3.8 2.9M19 13l.1-1.3a7.3 7.3 0 0 0-8.6-7.2A4.3 4.3 0 0 0 8.4 4a4.4 4.4 0 0 0-3.8 6.6A7.3 7.3 0 0 0 13 19a4.3 4.3 0 0 0 2.1.6A4.4 4.4 0 0 0 19 13"
      />
    </svg>
  );
}

SkypeIcon.propTypes = {
  className: PropTypes.string,
};

SkypeIcon.ICON_SIZE = ICON_SIZE;

export default SkypeIcon;
